import { EnvironmentProviders, inject, provideEnvironmentInitializer } from '@angular/core';
import { EventTypes, PublicEventsService } from 'angular-auth-oidc-client';
import { createPrefixMessage } from './rxjs/prefix-message.function';
import { LoggerWithConfigurationService } from './service/internal/logger-with-configuration.service';

// eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
export type AuthenticationFailedFn = () => unknown | Promise<unknown>;

export function withAuthenticationFailedCallback(
  fn: () => AuthenticationFailedFn,
  withDeps: true,
): EnvironmentProviders[];
export function withAuthenticationFailedCallback(
  fn: AuthenticationFailedFn,
  withDeps: false,
): EnvironmentProviders[];
export function withAuthenticationFailedCallback(
  fn: (() => AuthenticationFailedFn) | AuthenticationFailedFn,
  withDeps: boolean,
): EnvironmentProviders[] {
  return [
    provideEnvironmentInitializer(() => {
      const message = createPrefixMessage('withAuthenticationFailedCallback');
      const logger = inject(LoggerWithConfigurationService);
      const publicEventsService = inject(PublicEventsService);
      if (withDeps) {
        fn = fn() as () => AuthenticationFailedFn;
      }

      publicEventsService.registerForEvents().subscribe((event) => {
        if (event.type === EventTypes.CheckingAuthFinishedWithError) {
          logger.logWarning(
            message(
              'Encounter a authentication Failure. Trigger Authentication Failed Callback now.',
            ),
          );
          void fn();
        }
      });
    }),
  ];
}
